import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import { formatPropertyAddress, haveValue } from "../../helper/common";
import { Badge, Button, Icon, InfoList, Modal, Notice } from "../design";
import "./InsuranceActivatedPopup.css";

const InsuranceActivatedPopup = ({
  show,
  onClose,
  onComplete,
  propertyData,
}) => {
  const { _t } = useTranslator();

  if (!show) return null;

  const insuranceData = propertyData?.insurance_data;
  const paymentAmount = insuranceData?.payment_amount;
  const paymentDate = propertyData?.insurance_payment_date;
  const currentLang = localStorage.getItem("i18nextLng") || "en-us";
  const propertyAddress = formatPropertyAddress(propertyData, currentLang);

  return (
    <Modal
      open={show}
      onClose={onClose}
      size="sm"
      id="insurance-activated-popup"
      icon={
        <div className="ins-activated-icon-wrap">
          <Icon name="check" size={28} />
        </div>
      }
      title={_t("insurancePaymentReceivedPropertyAwarded")}
      description={
        haveValue(propertyAddress) ? (
          <>
            <strong>{propertyAddress}</strong>{" "}
            {_t("insurancePropertyIsNowAwarded")}
          </>
        ) : undefined
      }
      actionsLayout="stack"
      actions={
        <>
          <Button size="lg" onClick={onComplete}>
            {_t("addBeneficiaryAndContract")}
          </Button>
          <Button variant="secondary" size="lg" onClick={onClose}>
            {_t("doItLater")}
          </Button>
        </>
      }
    >
      <InfoList
        items={[
          {
            label: _t("insurancePremium"),
            value: haveValue(paymentAmount)
              ? `${paymentAmount} €${
                  haveValue(paymentDate)
                    ? ` · ${_t("paid")} ${moment(paymentDate).format("DD MMM YYYY")}`
                    : ""
                }`
              : "-",
          },
          {
            label: _t("policyStart"),
            value: _t("insuranceChoosePolicyStartNextStep"),
          },
          {
            label: _t("policy"),
            value: <Badge tone="warning">{_t("pendingContract")}</Badge>,
          },
          haveValue(insuranceData?.invoice_document) && {
            label: _t("receipt"),
            value: (
              <a
                href={insuranceData.invoice_document}
                target="_blank"
                rel="noreferrer"
              >
                {_t("downloadInvoice")}
              </a>
            ),
          },
        ].filter(Boolean)}
      />
      <Notice tone="warning" title={_t("oneStepLeftToActivatePolicy")}>
        {_t("insurancePendingContractExplanation")}
      </Notice>
    </Modal>
  );
};

export default InsuranceActivatedPopup;
